import React from "react";
import styles from './bespoke.module.scss';
import {uploadImage, removeImage} from '../../../actions/wizard';
import { connect } from "react-redux";
import EditIcon from '../../../components/editIcon';

class BespokePage extends React.Component<any, any>{

    constructor(props) {
        super(props);
        this.state = {
            showModal: false
        }
    }
   // handleUploadImage = (event) => {
   //    try {
   //         let target = event.target;
   //         const { pageDetails } = this.props;
   //         let {files} = target;
   //         if(!files || files.length <= 0 ){
   //             showSnackbar("Plese select images to upload!");
   //             return;
   //         }
   //         this.props.uploadImage({images: files, tag: pageDetails?.type.toLowerCase()});
   //     } catch (error) {
   //         console.error("Error while uploading image in component", error);
   //     }
   // }

    handleRemoveImage = (imageId)=>{
        try {
            //let target = event.target;
            const { pageDetails } = this.props;
            this.props.removeImage({imageId: imageId, tag: pageDetails?.type.toLowerCase()});
        } catch (error) {
            console.error("Error while removing image in component", error);
        }
    }
    handleShowHideModal = (flag)=>{
        try {
            if(flag){
                this.setState({
                    showModal: true
                });
                return;
            }
            this.setState({
                showModal: false
            })
            
        } catch (error) {
            console.error("Error in handleShowHideModal", error);
        }
    }
    render() {
      const { pageDetails } = this.props;
      const {images} = pageDetails;
        return (
          <React.Fragment>
               <div className={styles['bespoke-page']}>
                   <div className={styles['page-name']}>
                       {pageDetails?.name}
                       {
                           images && images.length ? <span onClick={()=>this.handleShowHideModal(true)} style={{zIndex: 12, position: "relative", paddingLeft: "20px", cursor: "pointer"}}><EditIcon /></span>: ""
                       }
                   </div>
                   <div className={styles['image-container']} style={(images && images.length === 1 ? {display: "block", textAlign: "center"}: {})}>
                       { images && images.length ?
                           (images || []).map((img, index)=>{
                               let {imageUrl } = img;
                               return(
                                   <div className={styles['image']} style={(images && images.length === 1 ? {display: "block", textAlign: "center"}: { "borderRight": (index===0 || index === 2) ? "1px dashed": "", "borderTop": (index===2 || index===3) ? "1px dashed": "", "borderBottom": images.length === 3 ? "1px dashed": ""})}>
                                       <img crossOrigin="anonymous" src={`${imageUrl}?ver=${new Date().getTime()}`} alt="Bespoke" />
                                   </div>
                               )
                           }): <div className={styles["addImageDiv"]}>
                                  {/*
                                  <label>
                                        <p className={styles["addImgeIcon"]}>
                                            <AddImageIcon fill={"#4a4a4a"} height="40px" width="40px"/>
                                        </p>
                                        <p style={{fontSize: "16px", color: "#4a4a4a", fontWeight: "bold"}}>ADD IMAGE</p>
                                        // <span style={{fontSize: "11px", color: "#9B9B9B"}}>PNG, (800 X 600)</span> 
                                        <input onChange={this.handleUploadImage} type="file" id="bespokeImages" style={{display: "none"}} /> 
                                    </label>


                                   */} 
                               </div>
                       }
                   </div>
               </div>
            {/* <ImageUpdate styles={styles} show={this.state.showModal} images={images} modalAction={this.handleShowHideModal} upload={} remove={this.handleRemoveImage} /> */}
            </React.Fragment>

        )
    }
    

}

export default connect(
    (state: any) => ({
        pageDetails: state.wizard.pageDetails
    }),
    {
        uploadImage,
        removeImage
    }
)(BespokePage);